import { useState } from 'react';
import ButtonSecondary from '../../button/button-secondary';
import DocumentComment from './document-comment';
import { DocumentCommentsTypes } from './types';

import styles from './documents.module.css';

export default function DocumentComments({
  comments,
  sendComment,
  commentInProgress,
  documentId,
  editComment,
  editCommentInProgress,
  editCommentIsSuccess,
  deleteComment,
  deleteCommentInProgress,
  commentsVisible,
}: DocumentCommentsTypes) {
  const [value, setValue] = useState('');
  const [rows, setRows] = useState(5);
  const [count, setCount] = useState(1);
  const [commentId, setCommentId] = useState('');

  const onKeyUp = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      setCount(count + 1);

      if (count > 4) {
        setRows(rows + 1);
      }
    }

    if (rows > 5 && e.key === 'Backspace') {
      const lines = (e.currentTarget.textContent)
        .replace(/\s/g, '/')
        .split('/');

      if (rows > lines.length) {
        setRows(lines.length);
        setCount(lines.length);
      }
    }
  };

  const onSubmit = () => {
    if (sendComment) {
      sendComment(value);
    }

    setValue('');
  };

  let commentsContent;

  if (!comments?.length) {
    commentsContent = <div className={styles.emptyComments}>No Comments</div>;
  } else {
    commentsContent = (
      <>
        {comments.map((item) => (
          <DocumentComment
            key={item.id}
            comment={item}
            documentId={documentId}
            editComment={editComment}
            editCommentInProgress={editCommentInProgress}
            editCommentIsSuccess={editCommentIsSuccess}
            deleteComment={deleteComment}
            deleteCommentInProgress={
              deleteCommentInProgress && commentId === item.id
            }
            setCommentId={setCommentId}
            commentsVisible={commentsVisible}
          />
        ))}
      </>
    );
  }

  return (
    <div className={styles.documentInfoCommentsWrapper}>
      <div className={styles.documentInfoCommentsTitle}>Add a comment</div>
      {commentsVisible && (
        <>
          <textarea
            rows={rows}
            className={styles.documentInfoComment}
            placeholder="Enter a comment..."
            value={value}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              setValue(e.target.value)
            }
            onKeyUp={(e) => onKeyUp(e)}
          />
          <ButtonSecondary
            text={commentInProgress ? 'Loading...' : 'Post'}
            className={`${styles.postCommentButton} ${
              !value.length ? 'button-white' : ''
            }`}
            disabled={Boolean(!value.length) || commentInProgress}
            onClick={onSubmit}
          />
        </>
      )}

      <div className={styles.commentsList}>{commentsContent}</div>
    </div>
  );
}
